import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedProductRiderStringModel {
    
    public readonly key = 'UnassignedProductRiderStringModel';
  }

export type ProductRiderStringModel = Async<string[]> | UnassignedProductRiderStringModel;

type MatchProductRiderStringModelOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (products: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (products: []) => TReturn;
  };

export const isLoading = (products: ProductRiderStringModel): products is Loading<string[]> =>
    products.key === 'Loading';

export const isLoaded = (products: ProductRiderStringModel): products is Loaded<string[]> => products.key === 'Loaded';

export const matchProductRiderStringModel = <TReturn>(options: MatchProductRiderStringModelOptions<TReturn>) => (
    products: ProductRiderStringModel
  ) => {
  
    switch (products.key) {
      case 'UnassignedProductRiderStringModel':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };